/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import GridEditRow from "../../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type CategoryDataProps = {
  formData: AbstractCase| Record<string, any>;
  translate: Function;
  basePath: string;
};

const CategoryData = ({ formData, translate, basePath }: CategoryDataProps) => {
  const section = "categoryData";
  const formPath = basePath + "/kategorie";
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Ihr Anliegen</Typography>
      </Grid>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"gender"} sx={summaryStyle.scrollToAnchor} />
        Suche Informationen zu
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: "gender",
          },
        }}
      >
        {translate("generalCategory." + formData.generalCategory, formData)}
      </GridEditRow>

      {["both", "death"].includes(formData.generalCategory) && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={"gender"} sx={summaryStyle.scrollToAnchor} />
            Todesfall aktuell?
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: "gender",
              },
            }}
          >
            {translate("deathCategory." + formData.deathCategory, formData)}
          </GridEditRow>
        </>
      )}
      {["inheritance", "both"].includes(formData.generalCategory) && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={"gender"} sx={summaryStyle.scrollToAnchor} />
            Erbe oder Vererben?
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: "gender",
              },
            }}
          >
            {translate("inheritanceCategory." + formData.inheritanceCategory, formData)}
          </GridEditRow>
        </>
      )}
    </>
  );
};

export default CategoryData;
